import { cva } from 'class-variance-authority'

export const clientBadgeVariants = cva(
  'inline-flex items-center rounded-[0.25rem] px-2 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-[var(--color-client-primary)] text-white',
        ghost: 'bg-[var(--color-client-secondary)] text-[var(--color-client-primary)]',
        outline:
          'bg-[var(--color-client-secondary)] text-[var(--color-client-primary)] border border-[var(--color-client-primary)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)
